// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AttributeLookupPagingResultModel from '../../model/attribute-lookup-paging-result-model';
import AttributeLookupPagingResultDTO from '../dto/attribute-lookup-paging-result-dto';
import dtoSchema from '../schemas/attribute-lookup-paging-result-schema';
import AttributeLookupModel from '../../model/attribute-lookup-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class AttributeLookupPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AttributeLookupPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => AttributeLookupModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: AttributeLookupModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<AttributeLookupPagingResultDTO>): AttributeLookupPagingResultModel;
  static toModel(dto: DeepPartial<AttributeLookupPagingResultDTO> | undefined | null): AttributeLookupPagingResultModel | undefined;
  static toModel(dto: DeepPartial<AttributeLookupPagingResultDTO> | undefined | null): AttributeLookupPagingResultModel | undefined {
    return dto ? new AttributeLookupPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AttributeLookupPagingResultModel> | AttributeLookupPagingResultModel): AttributeLookupPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as AttributeLookupPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AttributeLookupPagingResultModel, can not map to AttributeLookupPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
